<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './style.css';




</style>



// WEBPACK FOOTER //
// src/App.vue